import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { renderRoutes } from '@bravissimolabs/react-router-config';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import core from '@bravissimolabs/website-core';
import Meta from 'shared/containers/MetaContainer';
import ShopContainer from 'brastrap/editorial/shop-container/ShopContainer';
import ShopReviews from 'brastrap/promotional/shop-reviews/ShopReviews';
import { receiveShop } from 'shared/actions/shops';
import {
  getShopReviews,
  receiveReviews,
  receiveRating,
} from '../../../actions/shop-reviews';

const messages = defineMessages({
  title: {
    id: 'shop.title',
    defaultMessage: 'Bravissimo {shop} | Information & Opening Times',
  },
});

const ShopPage = props => (
  <Meta
    title={
      props.pageTitle ||
      props.intl.formatMessage(messages.title, { shop: props.shortName })
    }
    description={props.pageDescription}
    schemas={[{ ...props.localBusinessSchema, url: props.pageUrl }]}
  >
    {renderRoutes(props.route.routes)}
    {props.children || <ShopContainer {...props} />}
    {props.showReviews && (
      <ShopReviews
        reviews={props.reviews}
        onReadMoreClick={props.onReadMoreClick}
        showReadMore={props.showReadMore}
        showWriteReview={false}
        rating={props.rating}
      />
    )}
  </Meta>
);

/**
 * - Populate shop details
 *
 * @param {object} store
 * @param {object} props
 */
ShopPage.populateStore = async (store, props) => {
  const api = core.shop.shop;

  const shop = await api.getShop(props.params.shop);

  if (!shop) {
    throw new Error('404');
  }

  store.dispatch(receiveShop(shop));

  const { shopReviews: { limit } = {} } = store.getState() || {};
  const rating = await api.getShopRating();
  store.dispatch(receiveRating(rating));
  const reviews = await api.getShopReviews(limit);
  store.dispatch(receiveReviews(false, reviews, rating));
};

ShopPage.propTypes = {
  children: PropTypes.node,
  shortName: PropTypes.string,
  pageTitle: PropTypes.string,
  pageDescription: PropTypes.string,
  intl: intlShape,
  pageUrl: PropTypes.string,
  localBusinessSchema: PropTypes.object,
  route: PropTypes.shape({
    routes: PropTypes.array,
  }),
  reviews: PropTypes.arrayOf(PropTypes.object),
  onReadMoreClick: PropTypes.func,
  showReadMore: PropTypes.bool,
  rating: PropTypes.object,
  showReviews: PropTypes.bool,
};

const mapStateToProps = state => {
  const {
    app: {
      config: {
        shop: { showReviews },
      },
    },
    map,
    shops: { active },
    shopReviews: { reviews = [], limit, showReadMore, rating } = {},
  } = state;

  return {
    ...map,
    ...active,
    pageUrl: `${state.app.serverAndPort}${state.app.routing.url}`,
    reviews,
    limit,
    showReadMore,
    rating,
    showReviews,
  };
};

const mapDispatchToProps = dispatch => ({
  onReadMoreClick: () => dispatch(getShopReviews()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ShopPage));
